export default __webpack_public_path__ + "static/media/bookOpen.bb722217.svg";